export enum TicketStatus {
  Open = "open",
  Waiting = "waiting",
  Closed = "closed",
}
